// Keep the following in sync with packages/rum-recorder/src/index.ts
export { datadogRum } from './boot/rum.entry';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/~/@datadog/browser-rum/esm/index.js
// module id = ../../../../@datadog/browser-rum/esm/index.js
// module chunks = 5